<template>
  <div>
    <!--登入成功-->
    <div v-if="$store.getters.requestMessage" class="popup-wrap" :class="{ active: $store.getters.requestMessage }">
      <div class="popup-box">
        <div class="popup-success">
          <!-- eslint-disable-next-line -->
          <h5 v-if="isHtml" v-html="message" />
          <!-- Render message as text if it does not contain HTML tags -->
          <h5 v-else>
            {{ message }}
          </h5>
          <button class="button-style-5" @click="submit">
            <span>YES</span>
          </button>
          <button class="button-style-5" @click="hideModal">
            <span>NO</span>
          </button>
        </div>
        <a class="popup-close" @click="hideModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { showNotice } from '@/utils/tool'
export default {
  name: 'Request',
  data() {
    return {
      isHtml: false
    }
  },
  computed: {
    message() {
      if (!this.$store.getters.requestMessage) {
        return null
      }
      return this.$te(this.$store.getters.requestMessage.message) ? this.$t(this.$store.getters.requestMessage.message) : this.$store.getters.requestMessage.message
    },
    titleLabel() {
      return this.$te('Bao.notice') ? this.$t('Bao.notice') : 'Notice'
    },
    displayText() {
      return `${this.$t('Bao.request_clear')}`
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (newVal === 'closeModal') {
        this.hideModal()
      } else if (newVal != null) {
        if (this.message.indexOf('<') > -1) {
          this.isHtml = true
        } else {
          this.isHtml = false
        }
      }
    }
  },
  methods: {
    hideModal() {
      this.$store.commit('SET_REQUEST_MESSAGE', null)
    },
    submit() {
      showNotice(this.displayText, '', 'callAPI')
      this.hideModal()
    }
  }
}
</script>
